<template>
  <canvas
    :id="chartId"
    :width="(chartOptions.width || '100')"
    :height="(chartOptions.height || 25)"
  ></canvas>
</template>


<script>
export default {
  name: "ProgressTicksChart",
  props: ["chartId", "chartOptions", "chartData", "chartPlugins"],
  data() {
    return {};
  },
  methods: {
    renderChart() {
      function drawLine(ctx, line) {
        ctx.beginPath();
        ctx.lineWidth = line.lineWidth || 1;
        ctx.fillStyle = line.fillStyle;
        ctx.strokeStyle = line.fillStyle;
        // The x-coordinate of where to create the line to
        ctx.moveTo(line.from.X, line.from.Y);

        // The y-coordinate of where to create the line to
        ctx.lineTo(line.to.X, line.to.Y);
        ctx.stroke();
        ctx.save();
      }

      let canvas = document.getElementById(this.chartId);
      let ctx = canvas.getContext("2d");
      let colorCount = 0;
      let fromY = 0;
      let toY = ctx.canvas.height;
      let tickData = this.chartData.datasets
        ? this.chartData.datasets[0]
        : { data: this.chartData };

      for (
        let numOfTicks = 0;
        numOfTicks < tickData.data.length * 3;
        numOfTicks += 3
      ) {
        // Draw the line
        drawLine(ctx, {
          fillStyle: tickData.backgroundColor[colorCount++],
          from: {
            X: numOfTicks + 1,
            Y: fromY
          },
          to: {
            X: numOfTicks + 1,
            Y: toY
          }
        });
      }
    }
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    chartId: function(newId, oldId) {
      // this.$data._chart.destroy();
      if (newId !== oldId) {
        let canvas = document.getElementById(oldId);
        try {
          const context = canvas.getContext("2d");
          context.clearRect(0, 0, canvas.width, canvas.height);
          this.$nextTick(function() {
            this.renderChart();
          });
        } catch (error) {
          console.log(`${error}`);
          this.$nextTick(function() {
            this.renderChart();
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/chart/ProgressTicksChart.vue